import { Routes, Route } from "react-router-dom"; // Hapus BrowserRouter dari sini
import "@fortawesome/fontawesome-free/css/all.min.css";

// --- IMPORT SCROLL TO TOP ---
import ScrollToTop from "./components/ScrollToTop";

// Import Halaman Utama
import LandingPage from "./pages/index";

// Import Kursus
import KursusStarter from "./pages/Course/Starter";
import KursusBasic from "./pages/Course/Basic";
import KursusIndependent from "./pages/Course/Independent";
import KursusAdvance from "./pages/Course/Advance";

// Import Auth
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";

// Import Trial & Assessment
import TrialClass from "./pages/Trial/TrialClass";
import FreeTest from "./pages/Assessment/FreeTest";
import SoalTest from "./pages/Assessment/SoalTest";
import Result from "./pages/Assessment/Result";

// Import Dashboard
import IndonesianDashboard from "./pages/User/Dashboard";
import DashboardAdmin from "./pages/Dashboard Admin/Dashboard-admin";

// Import Program Selection
import ProgramSection from "./pages/Program Selection/program-selection";

// --- IMPORT COMPONENT DASHBOARD SISWA ---
import ClassDetail from "./components/Dashboard siswa/viewclass";
import CourseMaterials from "./components/Dashboard siswa/viewmaterial";
import KursusSemiPrivate from "./pages/Course/SemiPrivate";
import KursusPrivate from "./pages/Course/Private";
import FutureMentor from "./pages/Future Mentor/FutureMentor";
import FutureMentorDetail from "./pages/Future Mentor/FutureMentorDetail";
import AboutUs from "./pages/About Us/Index";
import MyClass from "./components/Dashboard siswa/MyClass";
import HowItWorks from "./pages/HowItWorks/HowItWorks";
import NotFound from "./pages/NotFound/NotFound";

function App() {
  return (
    <>
      {/* ScrollToTop tetap di sini, tapi tanpa BrowserRouter pembungkus */}
      <ScrollToTop />

      <Routes>
        {/* Route Utama */}
        <Route path="/" element={<LandingPage />} />
        {/* Route Program Selection */}
        <Route path="/program-selection" element={<ProgramSection />} />
        {/* Route Kursus */}
        <Route path="/Course/Starter" element={<KursusStarter />} />
        <Route path="/Course/Basic" element={<KursusBasic />} />
        <Route path="/Course/Independent" element={<KursusIndependent />} />
        <Route path="/Course/Advance" element={<KursusAdvance />} />
        <Route path="/Course/SemiPrivate" element={<KursusSemiPrivate />} />
        <Route path="/Course/Private" element={<KursusPrivate />} />
        {/* <Route path="/Course/Advance" element={<KursusAdvance />} /> */}
        {/* Route Auth */}
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password/:id" element={<ResetPassword />} />
        {/* Route Lainnya */}
        <Route path="/Trial/TrialClass" element={<TrialClass />} />
        <Route path="/assessment/free-test" element={<FreeTest />} />
        <Route path="/assessment/soal-test" element={<SoalTest />} />
        <Route path="/result" element={<Result />} />
        <Route path="/Future/FutureMentor" element={<FutureMentor />} />
        <Route path="/Future/Mentor/:slug" element={<FutureMentorDetail />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        {/* Route User Dashboard */}
        <Route path="/user/dashboard" element={<IndonesianDashboard />} />
        {/* <Route path="/user/my-classes" element={<MyClass />} /> */}
        {/* Route Detail Kelas (View Class) */}
        <Route path="/user/class/:id" element={<ClassDetail />} />
        {/* Route Materi Kursus (View Material) */}
        <Route path="/user/class/:id/materials" element={<CourseMaterials />} />
        {/* Route Admin */}
        <Route path="/admin/overview" element={<DashboardAdmin />} />
        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
